import { useQuery } from 'react-query';
import { useEffect, useRef } from 'react';
import { getPartner } from '../api/getPartner';

const usePartner = (partnerCode, ssoToken) => {
  const { data, isLoading, isError, refetch } = useQuery(
    'current_partner_' + partnerCode + ssoToken,
    () => getPartner(partnerCode, ssoToken),
    {
      refetchOnWindowFocus: false,
      staleTime: 300000,
    },
  );

  // Log the fetched data for debugging
  // console.log('Fetched partner data:', data);

  const intervalRef = useRef();

  useEffect(() => {
    if (data && data?.user && data?.user.user_role === '') {
      // console.warn('User role is empty, starting refetch interval...');
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          refetch();
        }, 10000); // after 50 fetched if every 5 seconds and after 150 at 1.5 second and after 28 at 10 seconds?!
      }
    } else if (data && data?.user && data?.user.user_role !== '') {
      // console.log('User role resolved, clearing refetch interval.');
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [data, refetch]);

  // if (isLoading) {
  //   console.log('Loading partner data...');
  // }

  if (isError) {
    console.error('Error fetching partner data');
  }

  return data;
};

export default usePartner;
